import axios from 'axios';
import moment from 'moment';
import '../../CSS/Table.css';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { Input, Radio, Drawer, Form } from 'antd';
import { API_DASHBOARD } from '../../../../../commons/api';
import localStorage from '../../../../../utils/localStorage';

const AnomalyFeedbackTable = (props) => {

const [action,setAction] = useState('yes');
const [openModal,setOpenModal] = useState(false);
const [feedbackForm,setFeedbackForm] = useState(props.feedbackForm);
const [,setComment] = useState('');


 
useEffect(() => {
    setFeedbackForm(props.notification ? props.notification : {});
    setOpenModal(props.openModal);
},[]);
 
useEffect(() => {
  setFeedbackForm(props.notification ? props.notification : {});
  setOpenModal(props.openModal);
},[props.notification,props.openModal]);


  const handleOk = () => {
    const { feedbackForm } = props;
    let payload = {
      ...feedbackForm,
      Timestamp: moment(feedbackForm.Timestamp, 'YYYY-MM-DD 00:00:00')
        .tz(props.currentTimeZone)
        .format('YYYY-MM-DD HH:mm:ss'),
      Action: action,
      Comment: Comment
    };
    const accessToken = localStorage.get('accessToken');
    const deviceTypeObject = {
      method: 'POST',
      url: `${API_DASHBOARD.Feedback}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    return axios(deviceTypeObject)
      .then(() => {
        setOpenModal(false);
        props.refereshData('refresh');
      })
      .catch(function () {
        return 'error';
      });
  };

  const handleCancel = () => {
    setOpenModal(false);
  };

    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 10 }
    };
    return (
      <div style={{ marginLeft: '9px' }}>
        {/* <Button type="primary" onClick={this.openModal}>
                    {translationCache &&
                      translationCache['Feedback'] &&
                      translationCache['Feedback'] ?
                      translationCache['Feedback'] :
                      'Feedback'}
        </Button> */}

        <Drawer
          open={openModal}
          width={1000}
          title="Prediction Feedback"
          onOk={handleOk}
          onClose={handleCancel}
        >
          <Form {...formItemLayout}>
            <Form.Item label="NotificationId">
              <Input value={feedbackForm.NotificationId} readOnly></Input>
            </Form.Item>
            <Form.Item label="Timestamp">
              <Input value={feedbackForm.Timestamp} readOnly></Input>
            </Form.Item>
            <Form.Item label="TagName">
              <Input value={feedbackForm.TagName} readOnly></Input>
            </Form.Item>
            <Form.Item label="Tag Description">
              <Input value={feedbackForm.TagDescription} readOnly></Input>
            </Form.Item>

            <Form.Item label="Action">
              <Radio.Group
                value={action}
                onChange={(e) =>  setAction(e.target.value)}
              >
                <Radio value="yes">Yes</Radio>
                <Radio value="no">No</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              label="Comment"
              onChange={(e) => {
                setComment(e.target.value);
              }}
            >
              <Input.TextArea value={Comment} />
            </Form.Item>
          </Form>
        </Drawer>
      </div>
    );
  };


const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(AnomalyFeedbackTable);
